import PropTypes from "prop-types"

const InvestmentShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  isSigned: PropTypes.bool.isRequired,
  profileType: PropTypes.string.isRequired,
  totalAmount: PropTypes.number.isRequired,
  hasSentFunds: PropTypes.bool,
  subscriptionId: PropTypes.string,
  receiverSourceId: PropTypes.string,
  isPartiallySigned: PropTypes.bool.isRequired,
  isProfileComplete: PropTypes.bool.isRequired,
  subscriptionAdminUrl: PropTypes.string,
})

export default InvestmentShape
